<div class="row">
  <div class="col-md-12">
    <div class="card">
      <div class="card-header text-center">
        <h2>REPORTE DE VENTAS</h2>

        <form
          action=""
          [formGroup]="buscarForm"
          (ngSubmit)="buscarExistencia()"
          class="form-horizontal form-material noprint "
          id="categoryform"
          novalidate
        >
          <button class="noprint" onclick="window.print();return false;">
            <i class="fa fa-print"></i>
          </button>
          <div *hasPermission="['administrador', 'almacen']" class="form-row">
            <div class="col-md-5 col-xs-12">
              <app-form-error-wrapper
                [control]="buscarForm.controls['vendedor']"
                [controlName]="'Vendedor'"
              >
                <label for="inputGroupSelect02">Vendedor</label>
                <select
                  class="custom-select"
                  id="inputGroupSelect02"
                  formControlName="vendedor"
                >
                  <option value="">Todos</option>
                  <option
                    *ngFor="let vendedor of users"
                    [ngValue]="vendedor.id"
                  >
                    {{ vendedor.nombres }} {{ vendedor.apellidos }}</option
                  >
                </select>
              </app-form-error-wrapper>
            </div>
          </div>
          <div class="form-row noprint">
            <div class="col">
              <app-form-error-wrapper
                [control]="buscarForm.controls['inicio']"
                [controlName]="'Fecha Inicio'"
              >
                <label for="inicio">Fecha Inicio</label>
                <input
                  class="form-control"
                  type="date"
                  id="inicio"
                  formControlName="inicio"
                />
              </app-form-error-wrapper>
            </div>
            <div class="col">
              <app-form-error-wrapper
                [control]="buscarForm.controls['fin']"
                [controlName]="'Fecha final'"
              >
                <label for="fin">Fecha fin</label>
                <input
                  class="form-control"
                  type="date"
                  id="fin"
                  formControlName="fin"
                />
              </app-form-error-wrapper>
              <!--              <input type="date" class="form-control" [ngModel]="final">-->
            </div>

            <div class="col-xs-12 col-md-2 mt-4">
              <button
                class="btn btn-info btn-lg btn-block text-uppercase waves-effect waves-light"
                [disabled]="buscarForm.invalid || isLoading"
              >
                <app-button-loader
                  [isLoading]="isLoading"
                  [label]="'Buscar'"
                ></app-button-loader>
              </button>
            </div>
            <!--              <button type="submit" class="btn btn-primary" (click)="ListarExistencia()">Buscar</button>-->
          </div>
        </form>
      </div>
      <div class="card-body">
        <table
          class="table table-condensed table-bordered table-hover table-responsive-md"
        >
          <thead>
            <tr>
              <th>#</th>
              <th>Codigo</th>
              <th>Producto</th>
              <th>U.M</th>
              <th class="text-center">Cantidad</th>
              <th class="text-center">Vendido</th>
              <th class="text-center">Total Compra</th>
              <th class="text-center">Ganancia</th>
            </tr>
          </thead>
          <tbody *ngFor="let data of existencia; let i = index">
            <tr>
              <th scope="row">{{ i + 1 }}</th>
              <td>{{ data.codigo }}</td>
              <td>{{ data.nombre }}</td>
              <td>{{ data.unidad }}</td>
              <td class="text-right">{{ data.cantidad }}</td>
              <td class="text-right">{{ data.total | number: '1.2-2' }}</td>
              <td class="text-right">{{ data.total2 | number: '1.2-2' }}</td>
              <td class="text-right">{{ data.ganancia | number: '1.2-2' }}</td>
            </tr>
          </tbody>
          <tfoot>
            <tr>
              <td colspan="3"></td>
              <td colspan="2 text-right">SUBTOTAL</td>
              <td class="text-right">
                <b> {{ totalSum | currency: 'BOB':'symbol-narrow':'1.2-2' }}</b>
              </td>
              <td class="text-right">
                <b> {{ tcompra | currency: 'BOB':'symbol-narrow':'1.2-2' }}</b>
              </td>
              <td class="text-right">
                <b>
                  {{ tganancia | currency: 'BOB':'symbol-narrow':'1.2-2' }}</b
                >
              </td>
            </tr>
          </tfoot>
        </table>
      </div>
    </div>
  </div>
</div>
